













































































































































































































































































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
// 引入组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import AddDeviceForm from '../../device-list/components/add-device-form.vue';
// 方法工具
import { cloneDeep } from 'lodash';
import { trim } from '@/utils/validators';
import Utils from '@/utils/common';
import { CHANNEL_LIST_CREATE, CHANNEL_LIST } from '../../router-names';
// axios请求
import {
  addOrEditChannelList,
  getAreasList,
  getDeviceListByParkAndArea,
  editInfoChannelList,
  detailChannelList
} from '@/api/parking-lot-management/index';
// 导入字典
import {
  DictDeviceType,
  dictChannelTypeMap,
  dictAlonePayMap,
  dictAllowableChannelTypeMap
} from '@/types/parking-lot-management/dictionaries';
import value from '*.json';
import * as _ from 'lodash';
// form表单项定义
export interface IForm {
  channelName: String; //通道名称
  channelCode: String; //通道名称
  parkId: String; //车场ID
  areaId: String;
  channelType: String; //通道类型 00 ：入场 01 ： 出场
  fromAreaId: String; //源区域
  toAreaId: String; //目标区域
  terminalId: String; //所属终端
  majorCameraId: String; //主摄像头
  displayId: String; //LED显示
  roadGateId: String; //道闸
  secondaryCameraId: String; //	次摄像头
  extendDeviceId: String; //	预留设备
}

@Component({
  components: { ParkingLotSearch, AddDeviceForm }
})
export default class AddEditChannel extends Vue {
  @Prop()
  dataForm!: any;

  @Prop({ type: String, default: '' })
  parkId!: string;

  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  @Prop({ type: Boolean, default: false })
  isParkdisabled!: boolean;

  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  @Prop({ type: Number, default: 0 })
  channelLength!: number;

  form: any = null;
  validatorsTrim = trim;
  currentParkId = '';
  areaOptions: IOption[] = []; //所属区域下拉
  areaFormOptions: IOption[] = []; //所属区域下拉
  majorCameraOptions: IOption[] = []; //主摄像头下拉
  secondaryCameraOptions: IOption[] = []; //次摄像头下拉
  displayOptions: IOption[] = []; //LED显示下拉
  roadGateOptions: IOption[] = []; //道闸下拉
  extendDeviceOptions: IOption[] = []; //预留设备
  isWenLv: boolean = 'wenlv,wenlvtest'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV); //查看图片文旅定制化
  // 通道类型
  channelTypeOptions: IOption[] = Utils.toLabelVal(dictChannelTypeMap);
  spining: boolean = false;
  //新增时的设备类型
  addDeviceType: string = '00';
  @Watch('visible')
  visibleChanged(val: boolean) {
    console.log('1111-------eeee->', val);
    if (val) {
      this.init();
      if (this.parkId != '') {
        this.getAreasList();
      }
    }
  }
  @Watch('parkId')
  parkIdChanged(val: boolean) {
    if (this.visible && val) {
      this.init();
    }
  }
  @Watch('dataForm', { deep: true })
  dataChanged(val: any) {
    console.log('1111-------->');
    if (this.visible && val) {
      this.init();
    }
    if (this.isEdit) {
      console.log(val, '0000---------->');
      this.getAreasList(val.parkId);
      this.getDeviceListByParkAndArea(val.parkId);
    }
  }

  @Watch('currentParkId')
  currentParkIdChanged(newVal: string) {
    // 车场Id变更需要更新区域下拉选项
    if (!newVal && !this.parkId) return;
    this.getAreasList();
    this.addDeviceType = '00';
    // 车场id变更需要更新设备下拉项
    this.getDeviceListByParkAndArea();
  }
  // @Watch('isEdit')
  // isEditChanged(val: boolean) {
  //   if (val) {
  //     this.init()
  //   }
  // }
  // 表单中车场ID变更监听
  parkIdChange(parkId: string) {
    this.currentParkId = parkId;
    // 清空区域和设备选项
    this.form.setFieldsValue({
      areaId: '',
      majorCameraId: '',
      displayId: '',
      roadGateId: '',
      secondaryCameraId: '', //	次摄像头
      extendDeviceId: '' //	预留设备
    });
    this.areaOptions = [];
  }

  created() {
    if (this.visible) {
      this.init();
    }
  }

  /**
   * 初始化form表单
   */
  init() {
    if (this.isEdit) {
      // 编辑状态
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const {
            channelName,
            channelCode,
            parkId,
            areaId,
            channelType,
            fromAreaId, //源区域
            toAreaId, //目标区域
            majorCameraId,
            displayId,
            roadGateId,
            secondaryCameraId, //	次摄像头
            extendDeviceId, //	预留设备
            terminalId //所属终端
          } = this.dataForm;
          return {
            channelName: this.$form.createFormField({
              value: channelName
            }),
            channelCode: this.$form.createFormField({
              value: channelCode
            }),
            parkId: this.$form.createFormField({
              value: parkId
            }),
            areaId: this.$form.createFormField({
              value: areaId
            }),
            channelType: this.$form.createFormField({
              value: channelType
            }),
            fromAreaId: this.$form.createFormField({
              value: fromAreaId
            }),
            toAreaId: this.$form.createFormField({
              value: toAreaId
            }),
            majorCameraId: this.$form.createFormField({
              value: majorCameraId
            }),
            displayId: this.$form.createFormField({
              value: displayId
            }),
            roadGateId: this.$form.createFormField({
              value: roadGateId
            }),
            secondaryCameraId: this.$form.createFormField({
              value: secondaryCameraId
            }),
            extendDeviceId: this.$form.createFormField({
              value: extendDeviceId
            }),
            terminalId: this.$form.createFormField({
              value: terminalId
            })
          };
        }
      });
    } else {
      // 新增状态
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            // 新增车场步骤进来，parkId自动带入表单
            parkId: this.$form.createFormField({
              value: this.isParkdisabled ? this.parkId : ''
            })
          };
        }
      });
    }
    this.currentParkId = this.parkId || (this.dataForm && this.dataForm.parkId);
  }

  /**
   * 提交保存
   */
  async handleSubmit(e: any) {
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        this.onAddOrEdit(values);
      }
    });
  }

  handleCancel() {
    if (+this.channelLength < 1) {
      this.$router.replace({
        name: CHANNEL_LIST
      });
    } else {
      this.form.resetFields();
      this.$emit('cancel');
      this.areaOptions = [];
      this.areaFormOptions = [];
      this.majorCameraOptions = [];
      this.secondaryCameraOptions = [];
      this.displayOptions = [];
      this.roadGateOptions = [];
      this.extendDeviceOptions = [];
    }
  }
  //查询name
  getOptionName(id: String, list: IOption[]) {
    let result: any = [];
    if (!id) return '';
    result = _.filter(list, function(o) {
      return o.value == id;
    });
    if (result.length > 0) return result[0].label;
    return '';
  }

  async onAddOrEdit(values: IForm) {
    // TIP: 和后端沟通接口返回ID给前端
    if (values.fromAreaId === values.toAreaId) return this.$message.warning('源区域和目标区域不能一致');
    values.displayId = values.displayId || '';
    values.secondaryCameraId = values.secondaryCameraId || '';
    values.roadGateId = values.roadGateId || '';
    values.extendDeviceId = values.extendDeviceId || '';
    if (this.spining) return;
    this.spining = true;
    const { majorCameraId, secondaryCameraId, displayId, roadGateId, extendDeviceId } = { ...values };
    const jsonName = {
      majorCameraName: this.getOptionName(majorCameraId, this.majorCameraOptions),
      secondaryCameraName: this.getOptionName(secondaryCameraId, this.secondaryCameraOptions),
      displayName: this.getOptionName(displayId, this.displayOptions),
      roadGateName: this.getOptionName(roadGateId, this.roadGateOptions),
      extendDeviceName: this.getOptionName(extendDeviceId, this.extendDeviceOptions)
    };
    try {
      const { data: channelId = '' } = await addOrEditChannelList({
        ...values,
        // 编辑状态id从dataForm中获取，否则为空
        ...(this.isEdit ? { channelId: this.dataForm.channelId } : {}),
        // isParkdisabled为true，车场id不可以修改外部带入
        ...(this.isParkdisabled ? { parkId: this.parkId } : {}),
        ...jsonName
      });
      const { data } = await detailChannelList({ channelId });
      this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
      this.form.resetFields();
      // 提交成功保存返回ID，再添加列表的编辑功能中有用
      this.$emit('ok', {
        ...data, // 用保存接口返回的id查询出的信息内容，补足编辑内容中的中文展示
        ...values, // 当前编辑内容
        channelId
      });
      this.areaOptions = [];
      this.areaFormOptions = [];
      this.majorCameraOptions = [];
      this.secondaryCameraOptions = [];
      this.displayOptions = [];
      this.roadGateOptions = [];
      this.extendDeviceOptions = [];
    } catch (e) {
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
    } finally {
      this.spining = false;
    }
  }

  /**
   * 获取区域列表下拉框
   */
  async getAreasList(parkId?: string) {
    try {
      const { data } = await getAreasList({
        parkId: parkId || this.currentParkId
      });
      this.areaOptions = data.map((item: any) => {
        return { label: item.areaName, value: item.areaId };
      });
      this.areaFormOptions = [...this.areaOptions, { label: '外部', value: '0000' }];
      if (!this.isEdit) {
        //默认选中第一条
        this.form.setFieldsValue({
          fromAreaId: this.areaFormOptions[0] ? this.areaFormOptions[0].value || '' : ''
        });
        this.form.setFieldsValue({
          toAreaId: this.areaFormOptions[0] ? this.areaFormOptions[0].value || '' : ''
        });
        this.form.setFieldsValue({
          areaId: this.areaOptions[0] ? this.areaOptions[0].value || '' : ''
        });
      }
    } catch (error) {
      this.$message.error((error && error.msg) || `获取区域信息失败`);
    }
  }

  /**
   * 获取摄像头等下拉框
   */
  async getDeviceListByParkAndArea(parkId?: string) {
    try {
      const majorCameraOptions: IOption[] = [],
        secondaryCameraOptions: IOption[] = [],
        displayOptions: IOption[] = [],
        roadGateOptions: IOption[] = [],
        extendDeviceOptions: IOption[] = [];
      const { data } = await getDeviceListByParkAndArea({
        parkId: parkId || this.currentParkId,
        channelId: this.isEdit ? this.dataForm.channelId || '' : ''
      });
      data.forEach((item: any) => {
        if (item.deviceType === DictDeviceType.Camera) {
          if (item.priority == 0) {
            majorCameraOptions.push({ label: item.deviceName, value: item.deviceId });
          } else {
            secondaryCameraOptions.push({ label: item.deviceName, value: item.deviceId });
          }
        } else if (item.deviceType === DictDeviceType.LED) {
          displayOptions.push({ label: item.deviceName, value: item.deviceId });
        } else if (item.deviceType === DictDeviceType.Barrier) {
          roadGateOptions.push({ label: item.deviceName, value: item.deviceId });
        } else {
          extendDeviceOptions.push({ label: item.deviceName, value: item.deviceId });
        }
      });
      this.majorCameraOptions = majorCameraOptions;
      this.secondaryCameraOptions = secondaryCameraOptions;
      this.displayOptions = displayOptions;
      this.roadGateOptions = roadGateOptions;
      this.extendDeviceOptions = extendDeviceOptions;
      if (!this.isEdit) {
        //默认选中第一条
        if (this.addDeviceType == '01' || this.addDeviceType == '00') {
          this.form.setFieldsValue({
            majorCameraId: this.majorCameraOptions[0] ? this.majorCameraOptions[0].value || '' : ''
          });
        }
        if (this.addDeviceType == '02' || this.addDeviceType == '00') {
          this.form.setFieldsValue({
            secondaryCameraId: this.secondaryCameraOptions[0] ? this.secondaryCameraOptions[0].value || '' : ''
          });
        }
        if (this.addDeviceType == '03' || this.addDeviceType == '00') {
          this.form.setFieldsValue({
            displayId: this.displayOptions[0] ? this.displayOptions[0].value || '' : ''
          });
        }
        if (this.addDeviceType == '04' || this.addDeviceType == '00') {
          this.form.setFieldsValue({
            roadGateId: this.roadGateOptions[0] ? this.roadGateOptions[0].value || '' : ''
          });
        }
        if (this.addDeviceType == '05' || this.addDeviceType == '00') {
          this.form.setFieldsValue({
            extendDeviceId: this.extendDeviceOptions[0] ? this.extendDeviceOptions[0].value || '' : ''
          });
        }
      }
    } catch (error) {
      this.$message.error((error && error.msg) || `获取设备信息失败`);
    }
  }

  // 设备添加弹窗展示状态
  isShowDeviceModel: boolean = false;
  closeModel() {
    // console.log('设备点击取消')
    this.isShowDeviceModel = false;
  }
  openModel(type: string) {
    this.addDeviceType = type;
    if (this.currentParkId === null && this.parkId === '') {
      return this.$message.warning('请先在通道界面选择所属车场');
    }
    this.isShowDeviceModel = true;
  }
  deviceAddOk() {
    this.isShowDeviceModel = false;
    this.getDeviceListByParkAndArea();
  }
  // 返回
}
